import { useEffect } from 'react';

import useIsInExtension from 'src/recruiting-portal/pages/extension/utils/useIsInExtension';

import sendExtensionMessage, { ExtensionMessage } from '../utils/sendExtensionMessage';

export type ChromeExtensionWidth = 'THIN' | 'THICK' | 'FULL';

/**
 * Requests a Chrome extension panel width mode, and requests it again whenever the wanted mode
 * changes. Pass null to make no request, for example while the wanted mode is still unknown.
 */
export default function useSetChromeExtensionWidth(width: ChromeExtensionWidth | null) {
  const isInExtension = useIsInExtension();

  // eslint-disable-next-line modernloop/no-use-effect.cjs -- Effect tells the host extension window which width to use.
  useEffect(() => {
    if (!isInExtension || !width) {
      return;
    }

    sendExtensionMessage(ExtensionMessage.SET_PANEL_MODE, { mode: width });
  }, [isInExtension, width]);
}
